module.exports = __webpack_public_path__ + "img/logout.bfa9f2f2.svg";